/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Section_IntegrationsInputs */

const en_settings_section_integrations = /** @type {(inputs: Settings_Section_IntegrationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integrations & Alerts`)
};

const de_settings_section_integrations = /** @type {(inputs: Settings_Section_IntegrationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integrationen & Benachrichtigungen`)
};

const fr_settings_section_integrations = /** @type {(inputs: Settings_Section_IntegrationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intégrations & Alertes`)
};

const es_settings_section_integrations = /** @type {(inputs: Settings_Section_IntegrationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integraciones y Alertas`)
};

const it_settings_section_integrations = /** @type {(inputs: Settings_Section_IntegrationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integrazioni & Avvisi`)
};

const nl_settings_section_integrations = /** @type {(inputs: Settings_Section_IntegrationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integraties & Meldingen`)
};

const pl_settings_section_integrations = /** @type {(inputs: Settings_Section_IntegrationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integracje & Powiadomienia`)
};

const fi_settings_section_integrations = /** @type {(inputs: Settings_Section_IntegrationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integraatiot & Hälytykset`)
};

const da_settings_section_integrations = /** @type {(inputs: Settings_Section_IntegrationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integrationer & Notifikationer`)
};

const sv_settings_section_integrations = /** @type {(inputs: Settings_Section_IntegrationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integrationer & Aviseringar`)
};

/**
* | output |
* | --- |
* | "Integrations & Alerts" |
*
* @param {Settings_Section_IntegrationsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const settings_section_integrations = /** @type {((inputs?: Settings_Section_IntegrationsInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Section_IntegrationsInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_settings_section_integrations(inputs)
	if (locale === "fr") return fr_settings_section_integrations(inputs)
	if (locale === "es") return es_settings_section_integrations(inputs)
	if (locale === "it") return it_settings_section_integrations(inputs)
	if (locale === "nl") return nl_settings_section_integrations(inputs)
	if (locale === "pl") return pl_settings_section_integrations(inputs)
	if (locale === "fi") return fi_settings_section_integrations(inputs)
	if (locale === "da") return da_settings_section_integrations(inputs)
	if (locale === "sv") return sv_settings_section_integrations(inputs)
	return en_settings_section_integrations(inputs)
});